import { ReactNode } from 'react'

type TestProps = {
    children: ReactNode
    id: string
}

const Test = ({ children, id }: TestProps) => <div data-tid={id}>{children}</div>

export default Test
